import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { IS_BROWSER } from 'src/utils'
import { Row, Col, Button, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { i18nTranslate } from 'src/utils'
import { pageNames } from 'src/routes/pathParams'
import {
  CommonForm,
  DualDropDownWithSeachBar,
  MetaDecorator,
} from 'src/views/components'
import { Pagination } from 'src/views/components'
import { getFilterParams, constructQueryParam } from 'src/deps'
import { TeamsListCard } from './TeamsList'
import { getTeamStatus } from './fixture'
import { createFormInput, filterTeamsInput } from './formInput'
import { schema } from './validationSchema'
import { teamContainer, costCenterContainer, userContainer } from 'src/models'
import './styles.scss'

@observer
class TeamManagement extends React.Component {
  @observable isCreateTeamManagementVisible = false
  @observable activePage = 1
  @observable searchStatus = 'All'
  @observable searchCostCenter = 'All'
  @observable searchTerm = ''
  @observable costCenterId = ''
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.fetchTeamList(this.props)
  }

  fetchTeamList = async filterParams => {
    if (IS_BROWSER) {
      const queryParams = getFilterParams(location)
      const params = {
        page: queryParams.page || 1,
        status: this.searchStatus,
        searchTerm: this.searchTerm,
        costCenter: this.searchCostCenter,
        ...filterParams,
      }
      this.activePage = parseInt(params.page)
      await teamContainer.getAllTeams(params)
      await userContainer.getUsersList()
      await userContainer.getUserListWithoutSize()
      await costCenterContainer.getAllCostCenter()
      await costCenterContainer.getAllCostCenterWithoutSize()
    }
  }

  handleSearchAndFilter = filterData => {
    if (this.activePage !== 1) {
      const queryParams = this.props?.location?.queryParams || {}
      delete queryParams.page
      constructQueryParam(this.props, queryParams)
      this.activePage = 1
    }
    const {
      currentlySelectedType,
      selectTeamStatus,
      selectCostCenter,
      searchTerm,
    } = filterData
    const params = {}
    if (currentlySelectedType === 'searchTerm') {
      this.searchStatus = 'All'
      this.searchCostCenter = 'All'
      this.costCenterId = ''
      params.searchTerm = searchTerm
      this.searchTerm = searchTerm
    } else {
      this.searchTerm = ''
      if (currentlySelectedType === 'selectTeamStatus') {
        this.searchStatus =
          selectTeamStatus !== '' && selectTeamStatus !== undefined
            ? selectTeamStatus
            : 'All'
      }
      params.selectTeamStatus =
        this.searchStatus !== 'All' ? this.searchStatus : ''
      if (currentlySelectedType === 'selectCostCenter') {
        const costCenterDetails =
          costCenterContainer?.costCenterList?.costCentres || []
        const defaultCostCenterId =
          costCenterDetails &&
          costCenterDetails.find(list => list.id == selectCostCenter)
        this.searchCostCenter =
          defaultCostCenterId !== undefined && defaultCostCenterId.name !== ''
            ? defaultCostCenterId.name
            : 'All'
        this.costCenterId = selectCostCenter
      }
      params.selectCostCenter =
        this.costCenterId !== 'All' ? this.costCenterId : ''
    }
    this.fetchTeamList(params)
  }
  handleSearchChangeData = value => {
    this.searchTerm = value
  }

  handlePagination = async pageNumber => {
    this.costCenterId = ''
    this.activePage = pageNumber
    const queryParams = getFilterParams(location)
    queryParams.page = pageNumber
    constructQueryParam(this.props, queryParams)
    this.fetchTeamList(this.props)
  }
  getCostCenter = props => {
    const { createForm = false } = props
    const costCenterDetails =
      costCenterContainer?.costCentreWithoutSizeData?.costCentres || []

    const label =
      createForm === true
        ? i18nTranslate(
            'myaccount.costCenterDropdownSelect',
            'Select cost center'
          )
        : i18nTranslate('myaccount.costCenterDropdown', 'All')

    const costCenterList = [
      {
        label,
        value: '',
      },
    ]
    costCenterDetails.length > 0 &&
      costCenterDetails.forEach(costCenter => {
        if (costCenter.status.toLowerCase() === 'active') {
          costCenterList.push({ label: costCenter.name, value: costCenter.id })
        }
      })
    return costCenterList
  }
  renderProps = () => {
    const costCenterList = this.getCostCenter({ createForm: true })
    return {
      renderPropArray: [this.RenderCostCenterLink()],
      costCenterList,
    }
  }
  renderSubmitButton = () => {
    return (
      <Row noGutters className="mt-3">
        <Button
          variant="primary"
          type="submit"
          className="create-team-button d-flex px-3 py-1 justify-content-center align-items-center mt-3 col-lg-4"
          data-testid="qa-create-team-button">
          {i18nTranslate('addTeamForm.submit', 'Create')}
        </Button>
        <Button
          onClick={() => this.handleCreateTeamManagement()}
          variant="outline-dark"
          className="ml-0 ml-lg-3 team-management-create-button d-flex px-3 py-1 justify-content-center align-items-center col-lg-4 mt-3"
          data-testid="qa-cancel-team-button">
          {i18nTranslate('addTeamForm.cancel', 'Cancel')}
        </Button>
      </Row>
    )
  }

  RenderCostCenterLink = () => {
    return (
      <Link to={pageNames.b2bCostCenter} data-testid="qa-add-cost-center">
        {i18nTranslate('teamManagement.addCostCenter', 'Add cost center')}
      </Link>
    )
  }

  handleCreateTeamSubmit = data => {
    const { description, teamName, costCenter } = data
    const teamData = {
      name: teamName,
      description,
      status: 'active',
      costCentreId: parseInt(costCenter),
      // costCent`re`Id
      teamBuyer: [],
    }
    teamContainer.createTeam(teamData)
  }

  handleCreateTeamManagement = () => {
    this.isCreateTeamManagementVisible = !this.isCreateTeamManagementVisible
  }

  renderCreateTeamView = () => {
    const formView = (
      <CommonForm
        schema={schema}
        formTypeJson={createFormInput(this.renderProps())}
        SubmitButtonProps={this.renderSubmitButton}
        onSubmit={this.handleCreateTeamSubmit}
        hasInlineSubmitButton={false}
        isToResetForm={true}
        classNameValue={{
          formClassName: 'add-team-form',
          formRowClassName: 'pt-2',
        }}
      />
    )
    return (
      <Container className="p-0 mb-2">
        <Col className="create-form-wrapper p-3 d-flex flex-column bg-white">
          <h4 data-testid="qa-team-management-heading" className="m-0">
            {i18nTranslate('teamManagement.createTeamHeading', 'Create Team')}
          </h4>
          {formView}
        </Col>
      </Container>
    )
  }

  render() {
    const costCenterList = this.getCostCenter({ createForm: false })
    const teamsData = teamContainer?.filteredTeamsData?.teams || []
    const usersData = userContainer?.userDataWithoutSize?.accountBuyer || []
    const pageableInfo = teamContainer?.filteredTeamsData?.pageableInfo || {}
    const teamsDataToShow = teamsData && teamsData.length ? teamsData : []
    const teamsTitle = i18nTranslate('teamsSearchBar.title', 'Teams')
    const { size = 0, totalCount = 0 } = pageableInfo
    const defaultSearchAndFilterValue = {
      defaultSearchTerm: this.searchTerm,
      defaultSearchStatus: this.searchStatus,
      defaultSearchCostCenter: this.searchCostCenter,
      costCenterList,
    }
    const filterTeamsForm = filterTeamsInput(defaultSearchAndFilterValue)

    const teamListCardCostCenter = this.getCostCenter({ createForm: true })
    const myAccountTeamManagementTitle = i18nTranslate(
      'myAccountTeamManagementPage.title',
      'Team Management | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountTeamManagementTitle}
          imageUrl=""
          imageAlt=""
          description="B2B Team Management Page"
          location={this.props}
        />
        <div className="team-management-page">
          {this.isCreateTeamManagementVisible && this.renderCreateTeamView()}
          <div className="bg-white team-management-table position-relative">
            {this.isCreateTeamManagementVisible === false && (
              <Button
                className="teammanagement-create-button"
                onClick={this.handleCreateTeamManagement}>
                {i18nTranslate('teamManagement.create', 'Create')}
              </Button>
            )}
            <DualDropDownWithSeachBar
              filterInput={filterTeamsForm}
              title={teamsTitle}
              handleChangeData={this.handleSearchChangeData}
              onSubmit={this.handleSearchAndFilter}
              searchBarClassName={'team-management-search-bar'}
            />
          </div>
          <TeamsListCard
            teamsData={teamsDataToShow}
            usersData={usersData}
            costCenters={teamListCardCostCenter}
            statuses={getTeamStatus({ isSearchStatusForm: false })}
          />

          {totalCount > size && (
            <Pagination
              handlePagination={this.handlePagination}
              totalPages={Math.ceil(totalCount / size)}
              active={this.activePage}
            />
          )}
        </div>
      </>
    )
  }
}

export { TeamManagement }

export default TeamManagement
